<template>
  <div>
      <el-card class="cardHeight">
          <div style="display:flex"><div class="block"></div>
           <span style="margin-left:4px">基础设置</span></div>
           <el-form style="margin-top:16px" label-width="112px">
              <el-form-item required label="报损菜品">
           <span @click="showDialog" style="color:#ff6000;cursor:pointer">选择商品</span>
              <div v-if="form.productList!=null && form.productList.length!=0">
              <el-table  :data="form.productList">
          <el-table-column align="center" label="序号" type="index"></el-table-column>
         <el-table-column align="center" label="菜品名称" prop="productName"></el-table-column>
        <el-table-column align="center" label="菜品名称" prop="categoryName"></el-table-column>
             <!-- <el-table-column  align="center" label="报损数量" >
              <template slot-scope="scope">
                  <el-input-number controls-position="right"  size="mini"
                  :min="1"
                   v-model="scope.row.num"></el-input-number>
              </template>
             </el-table-column> -->
             
               <el-table-column align="center" label="操作">
                  <template slot-scope="scope">
                <span style="cursor:pointer" @click="del(scope.$index)">删除</span>
              </template>
             </el-table-column>
              </el-table>
              </div>
              </el-form-item>
             
     

           </el-form>
           <div class="foot">
              <el-button @click="()=>{$router.push('/dishesDamage/dishesDamageList')}"
              class="cancel">取消</el-button>
              <el-button @click="save" class="saveBtn">保存</el-button>
           </div>
           <DishesDialog :dishesDialogVisible="isShowDishes"
 :selectType='selectType' :defoultSelect='selectDishesList' @handleDishesClose='dishesDialogClose'></DishesDialog>

      </el-card>
  </div>
</template>
<script>
import DishesDialog from '../merchantDiscountCreate/components/DishesDialog.vue'
  export default {
      components:{
          DishesDialog
      },
      data(){
          return{
          selectType:'',
          selectDishesList:[],
          isShowDishes:false,
          form:{
          creator:localStorage.getItem('merchantName'),
          merchantCode:localStorage.getItem('merchantCode'),
          merchantName:localStorage.getItem('merchantName'),
          type:'3',
          productList:[],
          createDt:'',
          remark:""
      }
          }
      },
      methods:{
          showDialog(){
              this.selectDishesList=this.form.productList
              this.isShowDishes=true
          },
          del(index){
             this.form.productList.splice(index,1)
          },
         async save(){
              console.log(this.form)
             let res=await this.$http.post('merchantActivityProduct/addList',this.form)
            if(res.data.code==200){
              this.$message({
                  type:"success",
                  message:'保存成功'
              })
              this.$router.push('/merchantActivityProduct')
            }else{
              this.$message.error(res.data.message)
            }
          },
          dishesDialogClose(bool,value){
              let arr=[]
              value.forEach(item=>{
                  arr.push(
                      {
                      productCode:item.productCode,
                      productName:item.productName,
                      categoryName:item.categoryName,
                      categoryCode:item.categoryCode,
                      merchantCode:localStorage.getItem('merchantCode'),
                      merchantName:localStorage.getItem('merchantName'),
                      num:1
                      }
                      )
              })
              this.form.productList.forEach(item=>{
              arr.forEach(i=>{
                  if(item.productCode===i.productCode){
                      i.num=item.num
                  }
              })
              })
              this.isShowDishes=false
              this.form.productList=arr
              this.form.productList.forEach(el=>{
                this.$set(el,'num',el.num)
              })
              console.log(bool,value,arr)
          }
      }
  }
</script>

<style lang="scss" scoped>
/deep/ .cardHeight{
  height: calc(100vh - 76px);
  position: relative;
}
.foot{
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  box-sizing: border-box;
  border-top: 1px solid #EAEAEA;
  padding: 14px 46px;
  justify-content: right;
  .saveBtn{
      background-color: #FFBD00;
      border-color: #FFBD00;
  }
}
.flex{
  display: flex;
  align-items: center;
}
.saveBtn:hover{
  color: #606266;
}
.block{
  display:block;
  width: 4px;
  height: 20px;
  background-color: #f59a23;
  border-radius: 4px;
}
/deep/ .el-form-item__label::after{
  content:":";
  padding-left: 2px;;
  
}
/deep/ .el-form>.el-form-item{
  margin-bottom: 20px;
}
.cancel{
  background-color: #fff;
}
</style>